function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.6103 5.25844C17.4787 3.31875 15.93 2.25 14.25 2.25H9.75C8.07 2.25 6.52125 3.31875 5.38969 5.25844C4.33219 7.07062 3.75 9.46875 3.75 12C3.75 14.5312 4.33219 16.9294 5.38969 18.7416C6.52125 20.6812 8.07 21.75 9.75 21.75H14.25C15.93 21.75 17.4787 20.6812 18.6103 18.7416C19.6678 16.9294 20.25 14.5312 20.25 12C20.25 9.46875 19.6678 7.07062 18.6103 5.25844ZM18.7303 11.25H15.7303C15.6717 9.71096 15.3653 8.19145 14.8228 6.75H17.6906C18.2644 8.00437 18.6431 9.5625 18.7303 11.25ZM16.7991 5.25H14.1056C13.7924 4.70655 13.4146 4.2029 12.9806 3.75H14.25C15.1875 3.75 16.0688 4.3125 16.7991 5.25ZM14.25 20.25H12.9834C13.4174 19.7971 13.7952 19.2935 14.1084 18.75H16.8019C16.0688 19.6875 15.1875 20.25 14.25 20.25ZM17.6906 17.25H14.8237C15.3662 15.8085 15.6727 14.289 15.7313 12.75H18.7313C18.6431 14.4375 18.2644 15.9956 17.6906 17.25Z",
  fill: "#085133"
});

var SvgCoinVertical = function SvgCoinVertical(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCoinVertical, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CoinVertical.017e3802.svg";
export { ForwardRef as ReactComponent };